import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';
import { titleEditorStoreSelector, useTitleEditorStore } from '@warehouse/title/domain';
import { titleTypeChipLines } from '@warehouse/title/infra';
import { getCombinedWorktype } from '@warehouse/title-shared/core';
import { Color, getIconByEntityNameAndTitleType } from '../../assets/icons';

const Wrapper = styled.div(
	({ theme }) => css`
		border: solid 1px ${theme.palette.light.backgroundAlt};
		border-radius: ${theme.spacing(0.5)};
		display: flex;
	`,
);

const TextWrapper = styled.div(
	({ theme }) => css`
		border-left: solid 1px ${theme.palette.light.backgroundAlt};
		display: flex;
		flex-direction: column;
		padding: ${theme.spacing(0.5, 1)};
	`,
);

const ImageWrapper = styled.div(
	({ theme }) => css`
		align-items: center;
		display: flex;
		justify-content: center;
		padding: ${theme.spacing(0.5)};

		& > img {
			height: 32px;
			width: 32px;
		}
	`,
);

function TitleTypeInfo() {
	const title = useTitleEditorStore(titleEditorStoreSelector.title);
	const workType = useTitleEditorStore(titleEditorStoreSelector.workType);
	const l1WorkType = useTitleEditorStore(titleEditorStoreSelector.l1WorkType);
	const detailLabel = useTitleEditorStore(titleEditorStoreSelector.workTypeDetails.selectedLabel);

	const combinedWorkType = getCombinedWorktype(title.readonly);
	const icon = getIconByEntityNameAndTitleType(combinedWorkType, Color.Colored);
	const { line1, line2 } = titleTypeChipLines({ workType, l1WorkType, detailLabel });

	return (
		<Wrapper aria-label="Title Type">
			<ImageWrapper>
				<img src={icon || undefined} alt="eidrIcon" />
			</ImageWrapper>
			<TextWrapper>
				<Typography variant="buttonLargeMedium">{line1}</Typography>
				{line2 && (
					<Typography color="text.secondary" variant="buttonSmallRegular">
						{line2}
					</Typography>
				)}
			</TextWrapper>
		</Wrapper>
	);
}

export default TitleTypeInfo;
